import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "name", "height", "width", "bordered", "shape", "alt", "isThemeable"];
import { getImageUrl, useGetImageUrl } from 'ui-images';
import { Image } from '../Image';
import { getBorderStyleProps, getCircleShapeStyleProps, getRoundedShapeStyleProps } from './Illustration.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const Illustration = _ref => {
  let {
      disabled = false,
      name,
      height,
      width,
      bordered = false,
      shape = 'default',
      alt = `${name} illustration`,
      isThemeable = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const heightPx = typeof height === 'number' ? `${height}px` : height;
  const widthPx = typeof width === 'number' ? `${width}px` : width;
  const themeSwitchingImageSrc = useGetImageUrl(name);
  const canvasImageSrc = getImageUrl(name);
  return /*#__PURE__*/_jsx(Image, Object.assign({
    objectFit: "contain",
    src: isThemeable ? themeSwitchingImageSrc : canvasImageSrc,
    alt: alt,
    responsive: false,
    inlineSize: widthPx,
    blockSize: heightPx,
    maxInlineSize: "100%",
    opacity: disabled ? 0.5 : 1
  }, (shape === 'rounded' || shape === 'thumbnail') && getRoundedShapeStyleProps(), shape === 'circle' && getCircleShapeStyleProps(), bordered && getBorderStyleProps(), rest));
};